import Layout from "../components/layout"
import SEO from "../components/seo"

import React, { Component } from "react"

import {  graphql } from "gatsby"
import lazySizes from 'lazysizes'

import "../styles/style.scss"

class List extends Component {

    state = {
        previewIndex: null
    }

    componentDidMount() {
      if (typeof window !== `undefined`) {
        window.hello=() => {document.location.href = "mailto:hello@gaspardbruno.com";console.log("Send us an email!");return "";}
        setTimeout(console.log.bind(console, "Hello, you're interested in what's going on behind? We'd love to hear from you at " + '%chello@gaspardbruno.com!' + '%c -> ' + '%chello()', 'color: #1812d6', 'color:black', 'font-weight:bold'), 0);
      }



        try {

            require('lazysizes/plugins/attrchange/ls.attrchange')
            require('lazysizes/plugins/unveilhooks/ls.unveilhooks.js')

            const UIkit = require("uikit/dist/js/uikit")

            UIkit.lightbox('.polygonDynamicsList', {
                animation: 'fade',
                videoAutoplay: true,
                velocity: 10,
                container: 'main'
            });

        } catch (e) {
            console.error(e)
        }

    }

    mouseEnter = (index) => {
        this.setState({ previewIndex: index })
    }

    mouseLeave = () => {
        this.setState({ previewIndex: null })
    }


    render() {

        const data = this.props.data.wpgraphql.pages.nodes[0]

        return (

        <Layout>

            <SEO title="Polygon Dynamics"/>
            <div className="polygonDynamicsList">


                {data.acfDocs.sectionProject.map(( section, index ) => (
                    <div className="polygonDynamicsListGroup" key={index} >

                        <h3 className="polygonDynamicsListTitle">Ref . {section.legend}</h3>
                        <div className="polygonDynamicsListRow">

                            {section.sectionProjectContent.map(( media, media_index ) => (



                               media.image ?
                                <div key={`section_project_content_${media_index}-${index}`}>
                                     <a
                                        className="polygonDynamicsListThumbnail lazyloadState lazyload"
                                        style={{backgroundImage: `url(${media.image.xsmall})` }} data-bg={media.image.small}
                                        href={media.image.xlarge}
                                        data-caption={section.texte}
                                        onMouseEnter={() => this.mouseEnter(`${index}-${media_index}`)}
                                        onMouseLeave={() => this.mouseLeave()} >
                                    </a>
                                     <div className={`polygonDynamicsListImagePreview ${this.state.previewIndex === `${index}-${media_index}` ? 'active' : ''}`}>
                                            <img src={media.image.medium} alt=""></img>
                                     </div>
                                </div>
                               :


                                     <div key={`section_project_content_${media_index}-${index}`}>
                                          <a
                                              className="polygonDynamicsListThumbnail lazyloadState lazyload"
                                              style={{backgroundImage: `url(${media.videoposter.xsmall})` }} data-bg={media.videoposter.small}
                                             href={media.video.mediaItemUrl} data-caption="Video" data-poster={media.videoposter.medium} data-caption={section.texte}
                                             onMouseEnter={() => this.mouseEnter(`${index}-${media_index}`)}
                                             onMouseLeave={() => this.mouseLeave()}>
                                         </a>
                                          <div className={`polygonDynamicsListImagePreview ${this.state.previewIndex === `${index}-${media_index}` ? 'active' : ''}`}>
                                              <video poster={media.videoposter.medium} preload="buffer" playsInline loop muted autoPlay>
                                                  <source src={media.video.mediaItemUrl} type="video/mp4"></source>
                                              </video>
                                          </div>
                                     </div>


                            ))}
                    </div>
                    </div>
                ))}

            </div>

        </Layout>

        )
    }
}

export default List


export const pageQuery = graphql`
query {
  wpgraphql {
    pages(after: "home-page") {
  nodes {
    title
    content
    acfDocs {
        forme3d {
          mediaItemUrl
        }
        sectionIntroduction {
            title
            subtitle
        }
        sectionProject {
            title
            reference
            texte
            legend
            modelviewerenvironmentimage{
                sourceUrl
            }
            sectionProjectContent {
                image {
                  sourceUrl
                  xsmall: sourceUrl(size: XSCOVER)
                  small: sourceUrl(size: SCOVER)
                  medium: sourceUrl(size: MCOVER)
                  large: sourceUrl(size: LCOVER)
                  xlarge: sourceUrl(size: XLCOVER)
                }
                videoposter{
                    sourceUrl
                    xsmall: sourceUrl(size: XSCOVER)
                    small: sourceUrl(size: SCOVER)
                    medium: sourceUrl(size: MCOVER)
                    large: sourceUrl(size: LCOVER)
                    xlarge: sourceUrl(size: XLCOVER)
                }
                video {
                    mediaItemUrl
                }
                size
            }
        }
      }
    }
  }
}
}
`
